module.exports = __webpack_public_path__ + "img/icon-detail-arrow.81cf9528.svg";